export const Images = {
  Logo: require("./vertical-logo.png"),
  IconLogo: require("./icon-logo.png"),
  HorizontalLogo: require("./horizontal-logo.png"),
};
